import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserData } from '../auth/userData';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-side-menu-content',
    templateUrl: './side-menu-content.component.html',
    styleUrls: ['./side-menu-content.component.scss'],
})
export class SideMenuContentComponent implements OnInit {
    @Output() sideNavItemClickedEvent = new EventEmitter<any>();

    tabsLabelRoutesMap = [
        { label: 'My Courses', route: 'student-course-lesson' },
        { label: 'My Projects', route: 'my-projects' },
        { label: 'My Challenges', route: 'my-challenges' },
        { label: 'Attendance', route: 'attendance-tutor' },
    ];

    userFullName = new BehaviorSubject<String>('admin digimaker');

    constructor(private userData: UserData) {}

    async ngOnInit() {
        this.userFullName.next(await this.userData.getName());
    }

    sideNavItemClickedEventHandler(event) {
        this.sideNavItemClickedEvent.emit(event);
    }
}
